<template>
  <v-app>
    <v-content>
      <router-view name="navigation"/>
      <router-view />
    </v-content>
  </v-app>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',

  components: {
  },

  computed: {
    ...mapGetters(['isLoggedIn'])
  },

  data: () => ({
    //
  }),

  methods: {
    ...mapActions(['refreshAction'])
  },

  created () {
    if (this.isLoggedIn) {
      // this.$router.push('/')
    } else {
      this.refreshAction()
        .then(() => {
          // this.$router.push({ name: 'Home' })
        })
        .catch(() => {
          this.$router.push({ name: 'Login' })
        })
    }
    document.title = 'Hjälp På Traven Online - Enkel reducering av alla svensk travlopp'
  }
}
</script>
